import { FC } from 'react';

import { FontAwesomeIcon, If } from '@hsp/react-component-library';

import { IExpanderProps } from 'types/components/table/components/expander';

const Expander: FC<IExpanderProps> = ({ canExpand, expanded }) => {
  return (
    <If condition={canExpand}>
      <div className="align-items-center d-flex justify-content-center">
        <FontAwesomeIcon icon={['fas', expanded ? 'chevron-up' : 'chevron-down']} />
      </div>
    </If>
  );
};

export default Expander;
